// Helper: reaction system
export const REACTIONS = [
  { type: 'heart', emoji: '❤️', label: 'Heart' },
  { type: 'clap', emoji: '👏', label: 'Clap' },
  { type: 'fire', emoji: '🔥', label: 'Fire' },
  { type: 'beer', emoji: '🍺', label: 'Beer' },
  { type: 'holeInOne', emoji: '⛳', label: 'Hole-in-One' },
  { type: 'strong', emoji: '💪', label: 'Strong' }
];

export const getUserReactionType = (post, userId) => {
  if (!post.reactions) {
    // Legacy: check old likes array
    if (post.likes?.includes(userId)) return 'clap';
    return null;
  }
  for (const [type, users] of Object.entries(post.reactions)) {
    if (users?.includes(userId)) return type;
  }
  return null;
};

export const getReactionTotal = (post) => {
  if (!post.reactions) return (post.likes || []).length;
  const reactionsTotal = Object.values(post.reactions).reduce((sum, arr) => sum + (arr?.length || 0), 0);
  return reactionsTotal;
};

export const getReactionBreakdown = (post) => {
  if (!post.reactions) {
    const likes = (post.likes || []).length;
    return likes > 0 ? [{ type: 'clap', emoji: '👏', count: likes }] : [];
  }
  return REACTIONS.map(r => ({
    ...r,
    count: (post.reactions[r.type] || []).length
  })).filter(r => r.count > 0);
};
